import React from "react";

const ConfirmationPage = () => {
    return (
        <div className="text-center p-5">
        Thanks for your order
        </div>
    );
}

export default ConfirmationPage;